import * as Flags from "country-flag-icons/react/3x2";

type Props = {
  code: string;
  width?: number;
};

export default function CountryFlag({
  code,
  width = 24,
}: Props) {
  const Flag =
    Flags[code.toUpperCase() as keyof typeof Flags];

  if (!Flag) return null;

  return (
    <Flag
      style={{
        width,
        height: "auto",
        borderRadius: 2,
        flexShrink: 0,
      }}
    />
  );
}